import { isWeb, isPhone } from '@helpers';
import { fullWidth } from '@components/frame';

/**
 * Converts facets object (from search API) into a flat { value: count } map
 */
export const parseFacetsToStorage = (facets: any): Record<string, number> => {
  const st: Record<string, number> = {};
  if (!facets) return st;

  Object.values(facets).forEach((v: any) => {
    v.forEach((i: any) => {
      st[i.value] = i.count;
    });
  });

  return st;
};

/**
 * Sanitizes oDataFilter — returns prefixed filter or empty string
 */
export const formatODataFilter = (oDataFilter: string | undefined | null): string => {
  const isCorrect = oDataFilter && oDataFilter.trim().length !== 0;
  return isCorrect ? `and ${oDataFilter}` : '';
};

/**
 * Calculates the width for each statistic tile
 */
export const calculateElementWidth = ({
  amountElements,
  gap,
  style,
  isPopupMode,
  popupWidth,
  scale,
}: {
  amountElements: number;
  gap: number;
  style?: any;
  isPopupMode?: boolean;
  popupWidth?: number;
  scale: (v: number) => number;
}): number => {
  if (amountElements === 0) return 0;

  const widthPassed = style?.width != null;
  const availableWidth = isPopupMode && popupWidth ? popupWidth : fullWidth;
  const horizontalPadding = isPopupMode ? scale(40) : scale(36);
  const calculatedWidth =
    ((widthPassed ? style?.width : availableWidth) - (widthPassed ? 0 : horizontalPadding) - (amountElements - 1) * gap) / amountElements;

  if (isWeb) return calculatedWidth;
  if (isPhone) return Math.max(120, calculatedWidth);
  if (widthPassed) return calculatedWidth;
  return Math.max(200, calculatedWidth);
};
